import { t } from './i18n';

export const currentRouteMatch = (matchRoutes, routeName) => {
    return matchRoutes.includes(routeName);
};

export const metaFind = (routeName) => {
    const t = meta.filter((item) => {
        return item.matchRoutes.includes(routeName);
    }, routeName);
    return t.length > 0 ? t[0].tags : [];
};

const addTitleSuffix = (str) => {
    return `${str} &#128640 ${t('appName')}`;
};

export const meta = [
    {
        matchRoutes: ['dashboard'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Dashboard')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'App dashboard and stats',
                },
            },
        ],
    },
    {
        matchRoutes: ['templates'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Templates')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Template list',
                },
            },
        ],
    },
    {
        matchRoutes: ['template-versions'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('TemplateVersions')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Template version list',
                },
            },
        ],
    },
    {
        matchRoutes: ['template-version-edit'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Template')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Template detail',
                },
            },
        ],
    },
    {
        matchRoutes: ['placeholders'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Placeholders')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Placeholder list',
                },
            },
        ],
    },
    {
        matchRoutes: ['placeholder'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Placeholder')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Placeholder detail',
                },
            },
        ],
    },
    {
        matchRoutes: ['files'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Files')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'File catalog',
                },
            },
        ],
    },
    {
        matchRoutes: ['directory'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Files')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'File catalog',
                },
            },
        ],
    },
    {
        matchRoutes: ['file'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Files')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'File detail',
                },
            },
        ],
    },
    {
        matchRoutes: ['snippets'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Snippets')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Snippet list',
                },
            },
        ],
    },
    {
        matchRoutes: ['snippet'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Snippets')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Snippet detail',
                },
            },
        ],
    },
    {
        matchRoutes: ['testing'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Tester')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Tester view',
                },
            },
        ],
    },
    {
        matchRoutes: ['tags'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Tags')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Tag list',
                },
            },
        ],
    },
    {
        matchRoutes: ['tag'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Tags')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Tag detail',
                },
            },
        ],
    },

    {
        matchRoutes: ['profile'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Profile')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'User profile',
                },
            },
        ],
    },
    {
        matchRoutes: ['users'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Users')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'View all users',
                },
            },
        ],
    },
    {
        matchRoutes: ['login'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Login')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'System login',
                },
            },
        ],
    },
    {
        matchRoutes: ['settings'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('Settings')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Client local settings',
                },
            },
        ],
    },
    {
        matchRoutes: ['batch-import-1'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('BatchImport')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Templating batch import',
                },
            },
        ],
    },
    {
        matchRoutes: ['batch-import-2'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('BatchImport')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Templating batch import',
                },
            },
        ],
    },
    {
        matchRoutes: ['batch-import-3'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('BatchImport')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Templating batch import',
                },
            },
        ],
    },
    {
        matchRoutes: ['batch-import-4'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('BatchImport')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Templating batch import',
                },
            },
        ],
    },
    {
        matchRoutes: ['ui-test'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('UITest')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: 'Templating UI test',
                },
            },
        ],
    },
    {
        matchRoutes: ['Error404'],
        tags: [
            {
                tag: 'title',
                params: {
                    innerHTML: addTitleSuffix(`${t('error404')}`),
                },
            },
            {
                tag: 'meta',
                params: {
                    name: 'description',
                    content: t('error404Text'),
                },
            },
        ],
    },
];

export const navs = () => {
    return {
        currentRouteMatch: currentRouteMatch,
        meta: meta,
        metaFind: metaFind,
    };
};

export default navs;
